import * as React from 'react';
import { createRoot } from 'react-dom/client';

import packageJson from '../../../package.json';
/**
 * XXX runtime renderer
 * XXX data attributes should be equal propType.toLowerCase()
 */
export default function renderer(selector, Component) {
  document.querySelectorAll(selector).forEach(el => {
    const props = Object.keys(Component.propTypes).reduce(
      (acc, p) =>
        el.dataset[p.toLowerCase()] ? { ...acc, [p]: el.dataset[p.toLowerCase()] } : acc,
      {},
    );

    if (!el.dataset.active) {
      const root = createRoot(el);
      root.render(<Component {...props} />);

      el.dataset.active = true;
    }
  });
  if (window && !window.bb_version) {
    window.bb_version = packageJson.dependencies['@front/blocks'];
  }
}
